<div class="main-view">
  <mat-card>
    <mat-card-content>
      <div class="flex" style="align-items: start">
        <div class="flex" style="font-size: 14px; align-items: start">
          <div style="width: 160px">
            <mng-out label="Code" contentClass="text-accent">
              <div
                class="flex"
                style="cursor: pointer"
                [matTooltip]="service.protokollZuordenbar() ? 'Zuordnung ändern' : 'Code der Dienstleistung'"
                (click)="zuordnungAendern()"
              >
                <div>
                  {{ detail().dienstleistungsCode ?? '-' }}
                </div>
                @if (service.protokollZuordenbar()) {
                  <div style="width: 20px; height: 20px">
                    <mat-icon style="width: 16px; height: 16px" color="accent" [svgIcon]="MGS_EDIT_ICON" />
                  </div>
                }
              </div>
            </mng-out>
            <mng-out label="Übernahme Datum" contentClass="text-accent"> {{ uebernahmeDatum() }} </mng-out>
          </div>
          <div style="width: 220px">
            <mng-out label="Arzt" contentClass="text-accent"> {{ detail().arztInfo }} </mng-out>
          </div>
          <div style="width: 220px">
            <mng-out label="Kunde" contentClass="text-accent"> {{ detail().kundenInfo }} </mng-out>
            <mng-out label="Merkur Kunde" contentClass="text-accent"> {{ detail().merkurKundenInfo }} </mng-out>
          </div>
        </div>

        <div class="flex-end" style="flex-flow: wrap">
          <button mat-icon-button color="accent" matTooltip="PDF erstellen" (click)="pdfFuerLaborDatenErmitteln()">
            <mat-icon [svgIcon]="MGS_PDF_ICON" />
          </button>

          @if (service.protokollBearbeitbar()) {
            <button mat-raised-button color="accent" (click)="laborProtokollBearbeitung(STATUS_UEBERNOMMEN)">
              Übernehmen
            </button>
            <button mat-raised-button color="accent" (click)="laborProtokollBearbeitung(STATUS_NICHT_UEBERNOMMEN)">
              Nicht übern.
            </button>
            <button mat-raised-button color="accent" (click)="laborProtokollBearbeitung(STATUS_INDIVIDUALKUNDE)">
              Individualk.
            </button>
          }

          <button
            mat-raised-button
            color="accent"
            replaceUrl="true"
            matTooltip="Laborprotokolle Übersicht"
            [routerLink]="`/${LABOR_PROTOKOLL_PATH}`"
          >
            Protokolle
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  @if (gridOptions) {
    <mng-tabulator [gridOptions]="gridOptions" (tableCreatedEvent)="onTableCreatedEvent($event)" />
  }
</div>
